(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[10450,14777,25591,65250,74206,44725,15653,93509,22432,52892,94386,73662,94596,44243,93375,22456,95660],{

/***/ 7099:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payrollsystem/terms-and-conditions",
      function () {
        return __webpack_require__(6636);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
const { useSyncExternalStore  } =  true ? __webpack_require__(67294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 6636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ PayrollSystemHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_shared_legal_termsAndConditions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10761);
/* harmony import */ var _components_layouts_payrollSystemWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80559);



var __N_SSP = true;
function PayrollSystemHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_payrollSystemWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_legal_termsAndConditions__WEBPACK_IMPORTED_MODULE_1__["default"], {
            category: "Payroll System",
            domain: "PayrollSystem.com"
        })
    });
}


/***/ }),

/***/ 80559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PayrollSystemWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/payrollsystem/logo/index.tsx


function PayrollSystemLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "306",
        height: "45",
        fill: "none",
        viewBox: "0 0 306 45",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_92)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#006838",
                        d: "M81.949 26.85h-6.673v-3.505h6.673c1.162 0 2.103-.186 2.821-.563.72-.378 1.24-.893 1.576-1.558.335-.665.503-1.426.503-2.282 0-.809-.168-1.57-.503-2.283-.336-.712-.863-1.281-1.576-1.719-.718-.431-1.653-.653-2.821-.653h-5.32V36.41h-4.42V10.765h9.74c1.983 0 3.672.347 5.062 1.048 1.39.701 2.45 1.66 3.18 2.887.726 1.229 1.091 2.63 1.091 4.2 0 1.653-.365 3.079-1.09 4.265-.731 1.186-1.785 2.097-3.181 2.732-1.39.635-3.08.952-5.062.952zM106.168 24.824l.036 2.624h-3.049c-1.587 0-2.78.288-3.576.857-.797.569-1.198 1.366-1.198 2.384 0 .773.263 1.42.784 1.935.521.515 1.27.773 2.247.773.868 0 1.629-.18 2.282-.54.653-.359 1.162-.796 1.54-1.323.377-.522.575-1.019.599-1.486l1.372 1.887c-.138.48-.384 1-.725 1.552a7.49 7.49 0 01-1.33 1.575 6.753 6.753 0 01-1.953 1.222c-.755.318-1.629.473-2.618.473-1.246 0-2.354-.251-3.33-.749-.977-.497-1.738-1.174-2.289-2.024-.551-.851-.827-1.815-.827-2.9 0-2.018.755-3.57 2.265-4.648 1.51-1.078 3.654-1.624 6.439-1.624h3.331v.012zm-.617 7.77v-9.088c0-1.012-.275-1.815-.827-2.414-.551-.599-1.395-.898-2.533-.898-.695 0-1.294.12-1.798.353-.503.234-.898.551-1.18.953a2.3 2.3 0 00-.425 1.354h-4.23c0-1.013.324-1.96.971-2.852.647-.892 1.558-1.617 2.732-2.168 1.174-.552 2.558-.827 4.157-.827 1.432 0 2.702.24 3.816.725 1.108.479 1.983 1.204 2.624 2.174s.958 2.18.958 3.636v8.47c0 .87.06 1.648.186 2.337.126.689.3 1.282.539 1.785v.282h-4.349c-.198-.455-.353-1.043-.467-1.755a13.092 13.092 0 01-.168-2.073l-.006.006zM116.861 17.354l4.529 14.27.755 4.474-2.942.755-6.925-19.499h4.583zm2.923 16.983l5.176-16.983h4.547l-7.644 21.967a14.66 14.66 0 01-.689 1.534 7.13 7.13 0 01-1.102 1.575 5.172 5.172 0 01-1.683 1.216c-.671.312-1.48.467-2.432.467-.378 0-.737-.03-1.085-.095a22.906 22.906 0 01-.976-.204l-.018-3.24c.12.011.263.023.431.035.168.012.306.018.413.018 1.055 0 1.858-.198 2.397-.593.539-.395.97-1.06 1.288-2l1.371-3.697h.006zM136.186 20.985v15.43h-4.247v-19.06h4.049l.192 3.63h.006zm5.829-3.75l-.036 3.947a8.175 8.175 0 00-.839-.108 11.206 11.206 0 00-.886-.036c-.989 0-1.798.18-2.439.546a3.717 3.717 0 00-1.473 1.521c-.342.653-.539 1.426-.599 2.318l-.971.072c0-1.587.21-3.019.635-4.307.426-1.288 1.055-2.306 1.905-3.055.845-.749 1.911-1.126 3.187-1.126.258 0 .539.024.839.072.299.048.527.102.677.155zM143.866 27.095v-.408c0-1.845.353-3.492 1.054-4.948.707-1.455 1.713-2.611 3.031-3.462 1.318-.85 2.9-1.276 4.757-1.276 1.857 0 3.462.425 4.78 1.276 1.324.85 2.336 2.007 3.037 3.462.707 1.456 1.055 3.11 1.055 4.948v.408c0 1.833-.354 3.48-1.055 4.942-.707 1.462-1.713 2.618-3.031 3.462-1.318.845-2.899 1.27-4.756 1.27-1.857 0-3.463-.425-4.781-1.27-1.324-.844-2.336-2-3.037-3.462-.707-1.462-1.054-3.11-1.054-4.942zm4.247-.408v.408c0 1.138.162 2.186.485 3.145.324.958.827 1.719 1.504 2.288.683.57 1.563.857 2.642.857 1.078 0 1.923-.288 2.605-.857.683-.57 1.187-1.33 1.504-2.288a9.934 9.934 0 00.485-3.145v-.408c0-1.126-.161-2.168-.491-3.127-.329-.958-.833-1.725-1.504-2.306-.676-.581-1.551-.875-2.635-.875-1.085 0-1.941.294-2.618.875-.677.581-1.174 1.348-1.498 2.306-.323.959-.485 2.001-.485 3.127h.006zM169.685 9.357v27.059h-4.266V9.357h4.266zM178.88 9.357v27.059h-4.265V9.357h4.265zM203.213 29.808c0-.706-.15-1.312-.449-1.815-.3-.503-.845-.97-1.636-1.39-.791-.425-1.935-.862-3.426-1.323-1.624-.492-3.073-1.079-4.349-1.756-1.282-.677-2.289-1.503-3.02-2.486-.736-.982-1.102-2.168-1.102-3.564s.384-2.606 1.156-3.666c.773-1.06 1.839-1.887 3.217-2.492 1.372-.605 2.965-.905 4.775-.905 1.905 0 3.546.354 4.924 1.055 1.378.7 2.444 1.647 3.187 2.833.748 1.186 1.12 2.498 1.12 3.93h-4.385c0-.845-.18-1.594-.539-2.246-.36-.654-.899-1.163-1.624-1.54-.725-.377-1.635-.563-2.737-.563-1.049 0-1.917.156-2.606.473-.695.318-1.21.749-1.552 1.288-.341.54-.509 1.15-.509 1.833 0 .635.198 1.198.599 1.69.402.49 1.007.94 1.821 1.347.815.408 1.851.791 3.109 1.156 1.893.563 3.463 1.21 4.721 1.947 1.258.737 2.198 1.6 2.821 2.6.623 1 .935 2.187.935 3.558 0 1.444-.378 2.69-1.138 3.732-.755 1.043-1.822 1.852-3.187 2.415-1.366.563-2.972.844-4.817.844-1.234 0-2.444-.161-3.636-.491a10.773 10.773 0 01-3.253-1.504 7.643 7.643 0 01-2.324-2.534c-.575-1.018-.863-2.204-.863-3.564h4.421c0 .833.144 1.546.432 2.133a3.802 3.802 0 001.204 1.437c.515.372 1.12.641 1.803.821a9.011 9.011 0 002.21.264c1.031 0 1.899-.144 2.6-.438.701-.293 1.222-.706 1.576-1.234.353-.527.527-1.138.527-1.833l-.006-.012zM213.744 17.354l4.529 14.27.755 4.474-2.942.755-6.925-19.499h4.583zm2.923 16.983l5.182-16.983h4.547l-7.644 21.967a14.66 14.66 0 01-.689 1.534 7.13 7.13 0 01-1.102 1.575 5.183 5.183 0 01-1.683 1.216c-.671.312-1.48.467-2.433.467a5.8 5.8 0 01-1.084-.095 22.906 22.906 0 01-.976-.204l-.018-3.24c.12.011.263.023.431.035.168.012.306.018.413.018 1.055 0 1.857-.198 2.397-.593.539-.395.97-1.06 1.288-2l1.371-3.697zM239.497 31.252a2.19 2.19 0 00-.318-1.156c-.209-.348-.617-.66-1.204-.94-.593-.282-1.467-.54-2.618-.773-1.347-.294-2.54-.677-3.57-1.145-1.024-.467-1.827-1.066-2.396-1.797-.569-.73-.857-1.623-.857-2.695 0-1.073.3-2.001.893-2.864.593-.862 1.444-1.557 2.546-2.084 1.102-.528 2.408-.791 3.912-.791 1.599 0 2.971.27 4.115.803 1.144.533 2.025 1.258 2.636 2.168.611.91.916 1.935.916 3.073h-4.247c0-.76-.287-1.438-.857-2.025-.569-.587-1.425-.88-2.563-.88-.731 0-1.33.114-1.804.341-.473.228-.826.527-1.054.887a2.21 2.21 0 00-.341 1.198c0 .437.113.79.341 1.102.228.312.629.587 1.198.827s1.372.473 2.402.695c1.456.305 2.708.695 3.762 1.174 1.049.473 1.857 1.084 2.42 1.833.564.749.845 1.69.845 2.827 0 1.139-.317 2.109-.952 2.978-.635.868-1.528 1.545-2.684 2.036-1.156.486-2.516.731-4.08.731-1.725 0-3.186-.305-4.385-.922-1.198-.617-2.102-1.408-2.719-2.379-.617-.97-.923-1.976-.923-3.019h4.104c.048.785.269 1.414.659 1.875a3.4 3.4 0 001.479 1.007 5.613 5.613 0 001.839.305c.761 0 1.402-.102 1.923-.305.515-.204.911-.486 1.18-.845.27-.36.408-.767.408-1.222l-.006-.018zM256.108 17.354v3.097h-10.747v-3.097h10.747zm-7.644-4.666h4.248V31.15c0 .587.084 1.037.257 1.348.168.312.408.521.713.623.306.108.665.156 1.072.156.294 0 .575-.018.845-.054.27-.036.485-.072.653-.108l.018 3.24c-.353.109-.761.199-1.222.282a9.042 9.042 0 01-1.594.126c-.976 0-1.839-.173-2.587-.52-.749-.348-1.336-.912-1.762-1.702-.425-.785-.635-1.833-.635-3.133V12.682l-.006.006zM267.784 36.763c-1.893 0-3.517-.407-4.877-1.216a8.428 8.428 0 01-3.163-3.3c-.748-1.39-1.12-2.96-1.12-4.715v-.707c0-1.995.378-3.732 1.126-5.206.749-1.473 1.78-2.611 3.091-3.414 1.312-.803 2.786-1.204 4.433-1.204 1.821 0 3.331.401 4.535 1.198 1.204.797 2.103 1.899 2.702 3.295.599 1.395.898 3.013.898 4.846v1.815h-14.724v-3.05h10.531v-.335a6.14 6.14 0 00-.449-2.15 3.726 3.726 0 00-1.258-1.623c-.563-.414-1.318-.618-2.253-.618-.934 0-1.737.264-2.384.785-.653.521-1.144 1.27-1.479 2.235-.336.964-.504 2.108-.504 3.426v.707c0 1.102.204 2.097.605 2.983.408.887.995 1.588 1.774 2.103.772.515 1.695.773 2.767.773 1.072 0 1.929-.204 2.732-.617a6.278 6.278 0 002.078-1.744l2.235 2.169c-.611.904-1.51 1.725-2.702 2.456-1.192.737-2.719 1.102-4.588 1.102l-.006.006zM282.951 21.23v15.186h-4.247V17.354h3.996l.245 3.876h.006zm-.689 4.948l-1.443-.018c0-1.761.287-3.33.862-4.714.575-1.378 1.426-2.468 2.546-3.259 1.12-.79 2.516-1.186 4.182-1.186 1.665 0 3.163.521 4.271 1.57 1.108 1.048 1.665 2.76 1.665 5.145v12.7h-4.247V24.088c0-.929-.138-1.654-.413-2.187a2.47 2.47 0 00-1.181-1.138c-.509-.234-1.12-.342-1.821-.342-.796 0-1.479.15-2.036.456a3.848 3.848 0 00-1.366 1.252 5.49 5.49 0 00-.773 1.833 9.74 9.74 0 00-.246 2.222v-.006zm11.82-1.126l-1.989.437c.012-1.54.299-2.953.862-4.235.563-1.288 1.396-2.318 2.498-3.091 1.103-.773 2.462-1.162 4.068-1.162 1.294 0 2.402.24 3.336.713.935.473 1.648 1.234 2.151 2.27.497 1.042.749 2.402.749 4.097V36.41h-4.265V24.064c0-.965-.138-1.708-.414-2.235-.275-.527-.665-.892-1.174-1.102-.503-.204-1.108-.306-1.815-.306-.659 0-1.234.12-1.737.36-.497.24-.917.575-1.258 1.006a4.37 4.37 0 00-.767 1.474 6.137 6.137 0 00-.257 1.797l.012-.006zM10.73 44.365a1.12 1.12 0 001.892 0l10.555-16.737c.216-.348.234-.785.036-1.138a1.134 1.134 0 00-.982-.581h-5.308c.12-1.726.521-3.403 1.198-5.002a15.626 15.626 0 013.373-4.996 15.791 15.791 0 014.996-3.373 15.615 15.615 0 016.122-1.234c2.127 0 4.181.413 6.122 1.234a15.53 15.53 0 014.996 3.373 15.79 15.79 0 013.373 4.996 15.613 15.613 0 011.234 6.122 15.626 15.626 0 01-4.607 11.118 15.79 15.79 0 01-4.996 3.373 15.613 15.613 0 01-6.122 1.234 15.626 15.626 0 01-11.118-4.607 1.124 1.124 0 00-1.588 0 1.124 1.124 0 000 1.587A17.92 17.92 0 0032.612 45c2.426 0 4.78-.473 6.997-1.414a17.823 17.823 0 005.709-3.852 17.92 17.92 0 005.265-12.705c0-2.426-.473-4.78-1.413-6.997a17.823 17.823 0 00-3.852-5.709 17.92 17.92 0 00-12.706-5.265c-2.426 0-4.78.473-6.997 1.413a17.823 17.823 0 00-5.709 3.852 17.919 17.919 0 00-3.851 5.709 17.91 17.91 0 00-1.378 5.87h-3.001c-.617 0-1.12.504-1.12 1.12 0 .618.503 1.121 1.12 1.121h8.518L11.67 41.657 3.145 28.143h3.553c.617 0 1.12-.503 1.12-1.12.012-13.658 11.13-24.783 24.8-24.783S57.406 13.36 57.406 27.03c0 .617.504 1.12 1.12 1.12.618 0 1.12-.503 1.12-1.12 0-3.648-.712-7.189-2.126-10.52a26.94 26.94 0 00-5.793-8.59A26.94 26.94 0 0032.618 0c-3.648 0-7.188.713-10.52 2.127a26.94 26.94 0 00-8.59 5.792 26.94 26.94 0 00-7.895 17.99H1.12a1.122 1.122 0 00-.946 1.719l10.555 16.737z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#12AA5F",
                        d: "M58.526 30.455c-.617 0-1.12.504-1.12 1.12v.785c0 .617.503 1.12 1.12 1.12.617 0 1.12-.503 1.12-1.12v-.784c0-.617-.503-1.12-1.12-1.12z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#61C086",
                        d: "M58.526 36.41c-.617 0-1.12.503-1.12 1.12v.785c0 .617.503 1.12 1.12 1.12.617 0 1.12-.503 1.12-1.12v-.785c0-.617-.503-1.12-1.12-1.12z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#009444",
                        d: "M32.618 12.67c-7.135 0-13.047 5.2-14.168 12.022h3.745c.37 0 .76-.035 1.12.096.647.24 1.114.785 1.312 1.444.137.473.084.929-.144 1.366-.312.599-.683 1.168-1.018 1.75-.456.784-.905 1.563-1.36 2.347l-1.618 2.798c-.024.042-.048.078-.072.12 2.534 4.073 7.051 6.787 12.203 6.787 7.931 0 14.359-6.428 14.359-14.36 0-7.93-6.428-14.358-14.36-14.358v-.012z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M30.33 24.878c-.504-.425-.78-.976-.791-1.557-.012-.593.263-1.169.778-1.618.312-.275.69-.479 1.103-.61v4.223c-.444-.096-.827-.228-1.085-.444l-.006.006zm3.03 2.786c.755.191 1.199.431 1.223.449.904.503 1.455 1.33 1.467 2.204.024 1.324-1.132 2.456-2.69 2.744v-5.397zm-4.18 2.773a1.007 1.007 0 00-1.019-.988 1.007 1.007 0 00-.989 1.018 4.26 4.26 0 00.486 1.905 4.773 4.773 0 001.228 1.492c.7.575 1.545.964 2.462 1.15l.018 1.15c.012.557.467.994 1.018.989.557-.012.995-.468.989-1.019l-.018-1.036a5.803 5.803 0 003.103-1.354 4.814 4.814 0 001.174-1.534 4.199 4.199 0 00.42-1.916c-.03-1.6-.96-3.068-2.499-3.924-.168-.096-.952-.503-2.198-.749v-4.583c.473.114.898.318 1.258.611.527.432.82.995.832 1.588.012.557.468.994 1.019.988.557-.012.994-.467.988-1.018-.018-1.192-.575-2.3-1.57-3.11a5.195 5.195 0 00-2.462-1.09l-.017-1.09a1.007 1.007 0 00-1.019-.988 1.011 1.011 0 00-.988 1.018l.018 1.09a5.2 5.2 0 00-2.426 1.175c-.965.844-1.48 1.965-1.462 3.163.018 1.168.557 2.252 1.504 3.055l.006.006c.676.563 1.533.808 2.372.94v5.601c-1.288-.377-2.217-1.36-2.235-2.528l.006-.012z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_92",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H305.763V45H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (PayrollSystemLogo);

// EXTERNAL MODULE: ./src/styles/variables/payrollsystemVariables.module.scss
var payrollsystemVariables_module = __webpack_require__(23100);
var payrollsystemVariables_module_default = /*#__PURE__*/__webpack_require__.n(payrollsystemVariables_module);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/layouts/payrollSystemWrapper.tsx










const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function PayrollSystemWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Payroll System",
                    domain: "PayrollSystem.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Payroll System",
                    domain: "PayrollSystem.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: `best of payroll systems companies ${region ? `in ${region}` : ""}`,
                        textColor: (payrollsystemVariables_module_default()).sloganColor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 97943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Facebook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#4780c0",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1514",
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.121 10H43.208V25H26.121z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1514)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M33.155 24.318h3.04v-6.881h2.12l.232-2.301h-2.353v-1.31c0-.548.116-.756.7-.756h1.653v-2.388h-2.115c-2.268 0-3.289.898-3.289 2.618v1.841h-1.586v2.329h1.586l.012 6.848z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Facebook);


/***/ }),

/***/ 22371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Twitter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#35a9ff",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.025 10H43.111999999999995V25H26.025z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32_1513)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M26.01 22.15a10.97 10.97 0 005.135 1.374 11.06 11.06 0 005.201-1.167c1.58-.8 2.878-1.965 3.755-3.369.877-1.403 1.298-2.99 1.217-4.59a6.803 6.803 0 001.779-1.595 7.52 7.52 0 01-2.012.484c.736-.38 1.289-.984 1.553-1.697a7.756 7.756 0 01-2.22.75 3.665 3.665 0 00-1.983-.933c-.76-.111-1.54.002-2.22.32-.68.32-1.22.826-1.537 1.442a2.725 2.725 0 00-.218 1.966 11.02 11.02 0 01-3.997-.927 9.796 9.796 0 01-3.218-2.277 2.746 2.746 0 00-.38 2.234c.203.76.727 1.424 1.467 1.856a3.872 3.872 0 01-1.553-.381c-.01.715.265 1.41.777 1.966s1.228.939 2.026 1.081a4.064 4.064 0 01-1.553.055 3.1 3.1 0 001.24 1.525 3.804 3.804 0 002.022.602 7.394 7.394 0 01-2.492 1.114 7.931 7.931 0 01-2.79.168z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_1513",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17.048V12.164H0z",
                        transform: "translate(26.025 11.364)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Twitter);


/***/ }),

/***/ 43808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pinterest() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#e60023",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1516",
                style: {
                    maskType: "alpha"
                },
                width: "19",
                height: "15",
                x: "25",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M25.93 10H43.016999999999996V25H25.93z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1516)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M30.756 18.573a.327.327 0 00.382-.078.262.262 0 00.056-.117c.037-.14.129-.486.172-.631.043-.145.037-.263-.123-.436a2.15 2.15 0 01-.573-1.541c-.007-.505.1-1.005.314-1.47.214-.466.53-.887.929-1.239a4.177 4.177 0 011.392-.806 4.492 4.492 0 011.631-.244c2.33 0 3.607 1.29 3.607 3.01 0 2.262-1.104 4.172-2.75 4.172a1.46 1.46 0 01-.613-.103 1.331 1.331 0 01-.494-.343 1.168 1.168 0 01-.27-.509 1.1 1.1 0 01.014-.564c.26-.994.765-2.066.765-2.792.02-.15.005-.3-.045-.444a1.03 1.03 0 00-.244-.388 1.162 1.162 0 00-.4-.26 1.265 1.265 0 00-.483-.087c-.924 0-1.67.866-1.67 2.028-.006.428.088.853.277 1.245l-1.116 4.273a8.05 8.05 0 000 2.982c.004.02.014.038.03.053a.12.12 0 00.055.03.13.13 0 00.064 0 .12.12 0 00.055-.032 8.308 8.308 0 001.566-2.57c.104-.351.616-2.161.616-2.161.233.312.549.566.918.738.37.171.782.256 1.197.245 2.787 0 4.673-2.301 4.673-5.384 0-2.324-2.176-4.468-5.48-4.468-4.12 0-6.166 2.675-6.166 4.903-.056 1.34.505 2.542 1.714 2.988z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pinterest);


/***/ }),

/***/ 8281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/oneElement/index.tsx
var oneElement = __webpack_require__(36895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/styles.module.scss
var styles_module = __webpack_require__(48378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/Share.tsx



const Share = ({ shareList  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shareList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: `cursor-pointer  ${(styles_module_default())[el.name]}`,
                onClick: ()=>{
                    window.open(el.link, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                    return false;
                },
                children: el.icon
            }, index))
    });
};
/* harmony default export */ var share_Share = (Share);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Facebook.tsx
var Facebook = __webpack_require__(97943);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Twitter.tsx
var Twitter = __webpack_require__(22371);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/pinterest.tsx
var pinterest = __webpack_require__(43808);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx









function Mobile() {
    const { asPath  } = (0,router.useRouter)();
    const { blogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const shareList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
            link: `https://www.facebook.com/sharer/sharer.php?u=https://${domain.name}${asPath}`,
            name: "facebook"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {}),
            link: `https://twitter.com/share?url=https://${domain.name}${asPath}`,
            name: "twitter"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pinterest/* default */.Z, {}),
            link: `http://pinterest.com/pin/create/button/?url=https://${domain.name}${asPath}`,
            name: "pinterest"
        }, 
    ];
    const myList = [
        {
            title: "Contents",
            slug: "contents",
            content: (0,sharedUtils/* getMainTitlesNavigationFromBody */._H)(blogPost?.model.body)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `   px-5 py-10  max-h-[80vh] flex flex-col justify-between `,
        children: [
            myList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(oneElement/* default */.Z, {
                    content: el.content
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `mt-4 text-sm font-bold`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `flex  gap-2 mt-3 justify-center  `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Share, {
                            shareList: shareList
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OneElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25086);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);



function OneElement({ content  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (content?.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linksList)}      `,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg mt-8 mb-5 hidden lg:block ",
                    children: "Contents"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto",
                    children: content?.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `
                                ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bulletedListItem)} pl-5    
                                     pb-5  `,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: el?.link ?? "#",
                                dangerouslySetInnerHTML: {
                                    __html: el?.title
                                },
                                onClick: ()=>setModal({
                                        active: false,
                                        content: undefined
                                    }),
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linkColor)}   block  cursor-pointer text-sm `
                            })
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 48378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__EYfOu","twitter":"styles_twitter__47r59","pintrest":"styles_pintrest__w6OTr"};

/***/ }),

/***/ 25086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__aZ9m3","linksList":"style_linksList__xLuOw","bulletedListItem":"style_bulletedListItem__H1JoX"};

/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 14777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","legal":"legal_legal__qUt4s","ccpaMainContainer":"legal_ccpaMainContainer__EgCgv","decimalStyleOnlyLi":"legal_decimalStyleOnlyLi__qBRw_","decimalStyle":"legal_decimalStyle__ostDo","alphaStyle":"legal_alphaStyle__B5bJA","timeStyle":"legal_timeStyle__bx7dw"};

/***/ }),

/***/ 23100:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sloganColor":"#515151","whyUsBriefColor":"#747474"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,10761,49774,92888,40179], function() { return __webpack_exec__(7099); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);